import { addDays } from "date-fns/addDays";
import { configs } from "../../app/app-configs";
import { Pagination } from "../../model/pagination";

export interface StaffAttendance {
  id: number;
  businessUserId: number;
  businessUserName: string;
  checkIn: string;
  checkInDate: string;
  checkOut: string;
  markerId: number;
  markedBy: string;
  source: string;
}

export interface StaffAttendanceSummary {
  todayCount: number;
  currentWeekCount: number;
  currentMonthCount: number;
  lastMonthCount: number;
}

export interface StaffAttendanceRequest {
  id?: number;
  businessUserId: number;
  checkIn: string;
  checkOut?: string;
}

export interface StaffAttendanceSearchCriteria {
    pagination: Pagination;
    from: string;
    to: string;
    name: string;
}

export const getDefaultStaffAttendanceSearchCriteria =
    (): StaffAttendanceSearchCriteria => {
        return {
            pagination: { page: 0, size: configs.PAGE_SIZE },
            name: '',
            from: addDays(new Date(), -7).toISOString().slice(0, 10),
            to: new Date().toISOString().slice(0, 10),
        };
    };